let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jke3X")).then(() => parcelRequire('hJWhT'));